import { useParams } from "react-router-dom";
import { ContractorCardProvider } from "../context";
import { ContractorCardContent } from "./ContractorCardContent";
import { DirectoryNoIdAlert } from "@/components/directory";

export const ContractorCardDirectory = () => {
  const { contractorCardId } = useParams();
  if (!contractorCardId) return <DirectoryNoIdAlert />;

  return (
    <ContractorCardProvider contractorCardId={contractorCardId}>
      <ContractorCardContent />
    </ContractorCardProvider>
  );
};
